<form (ngSubmit)="submit()" [formGroup]="form">
	<h5 class="mb-4">{{ "RESET_PASSWORD.TITLE" | translate }}</h5>

	<div class="mb-2">
		<app-input
			formControlName="codigoValidacaoSenha"
			[labelText]="'RESET_PASSWORD.LABEL.VERIFICATION_CODE' | translate"
			[placeholderText]="
				'RESET_PASSWORD.PLACEHOLDER.VERIFICATION_CODE' | translate
			"
			[showErrors]="true"
			[isRequired]="true"
			inputGroupIcon="bi bi-shield-check"
			data-cy="validation-code"
		></app-input>
	</div>

	<ng-container formGroupName="confirmarSenhaGroup">
		<div class="mb-2">
			<app-input
				formControlName="novaSenha"
				type="password"
				[labelText]="'RESET_PASSWORD.LABEL.NEW_PASSWORD' | translate"
				[placeholderText]="
					'RESET_PASSWORD.PLACEHOLDER.NEW_PASSWORD' | translate
				"
				[showErrors]="true"
				[isRequired]="true"
				inputGroupIcon="bi bi-key"
				data-cy="new-password"
			></app-input>
		</div>

		<app-input
			formControlName="confirmarSenha"
			type="password"
			[labelText]="
				'RESET_PASSWORD.LABEL.CONFIRM_NEW_PASSWORD' | translate
			"
			[placeholderText]="
				'RESET_PASSWORD.PLACEHOLDER.CONFIRM_NEW_PASSWORD' | translate
			"
			[showErrors]="true"
			[isRequired]="true"
			inputGroupIcon="bi bi-key"
			data-cy="confirm-new-password"
		></app-input>
		<app-validation-errors
			[abstractControl]="passwordGroup"
		></app-validation-errors>
	</ng-container>

	<app-validation-errors [abstractControl]="form"></app-validation-errors>

	<button
		[disabled]="form.invalid || isLoadingBtn"
		type="submit"
		class="btn btn-primary btn-block submit-button"
	>
		<ng-container *ngIf="isLoadingBtn">
			<span
				class="spinner-border spinner-border-sm me-2"
				role="status"
			></span>
		</ng-container>
		{{ "RESET_PASSWORD.TITLE" | translate }}
	</button>

	<div class="text-center">
		<a
			class="link-primary"
			type="button"
			(click)="goToLoginPage()"
			data-cy="return-to-login"
		>
			{{ "RESET_PASSWORD.LABEL.RETURN_LOGIN" | translate }}
		</a>
	</div>
</form>
